import { Skeleton } from '@mui/material'
import React, { FC } from 'react'
import LoadingSpinnerBackdrop from './LoadingSpinner'

interface IProps {
  loading: boolean,
  children: React.ReactNode
}

const PageWithLoad: FC<IProps> = ({ loading, children }) => {
  if (loading) {
    return <PageSkeleton />
  }
  return <>{children}</>
}

const PageSkeleton: FC<any> = () => {
  return (
    <>
      <Skeleton width={'100%'} height={250} />
      <LoadingSpinnerBackdrop />
    </>
  )
}
export default PageWithLoad
